// extracted by mini-css-extract-plugin
export var closeButton = "_k4-1";
export var closeX = "_k4-3";
export var container = "_k4-0";
export var image = "_k4-2";